import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReadService } from './read.service';
import FileSaver from 'file-saver';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { MessageService } from 'primeng';
import { Message } from '../classes/Message';

@Injectable({ providedIn: 'root' })
export class ReportService<TEntity, TFilter> extends ReadService<TEntity, TFilter> {
  url = '/api/report';
  entityTitle = 'Report';

  constructor(
    http: HttpClient,
    handlersFactory: HttpResponsesHandlersFactory,
    private messageService: MessageService,
  ) {
    super(http, handlersFactory);
  }

  loadFilterParam(): Promise<any> {
    return this.handleRequest(
      this.http.get(`${this.url}` + '/filterParam'),
      this.handlersFactory.getForReadAll(),
    );
  }

  downloadReport(filter: any, fileName?: string) {
    let params = this.constructHttpParams(filter);
    //console.log(params)
    let prom = this.http.get(this.url + '/download', { params: params, responseType: 'blob' });
    prom.subscribe(
      (x) => this.handleDownloadFile(x, fileName),
      (error) => {
        this.messageService.add(Message.Error('Impossible to download the sheet.'));
      },
      () => {
        this.messageService.add(
          Message.Success('Downloaded succesful. Check your download folder.'),
        );
      },
    );

    return prom;
  }

  public handleDownloadFile(blob, fileName) {
    let fName = fileName ? fileName : 'report.csv';
    FileSaver.saveAs(blob, fName);
  }

  public getSummaryPage(filter: any): Promise<any> {
    //public getSummaryPage(filter: TFilter): Promise<IPageResult<TEntity>> {
    let params = this.constructHttpParams(filter);

    return this.handleRequest(
      this.http.get(`${this.url}` + '/summary', { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }

  public updateTransactionLineData(transactionLineItem: any): Promise<any> {
    let updateUrl = this.url + '/update';
    return this.handleRequest(
      this.http.post(updateUrl, transactionLineItem),
      this.handlersFactory.getForReadAll(),
    )
      .then(this.extractData)
      .catch(this.handleError);
  }

  public backfillExpensesReport(fromDate: string) {
    return this.http.post(`${this.url}/backfill`, { fromDate }).toPromise();
  }

  //public extractData(res: any) {
  //    return res;
  //}

  //public handleError(errorResponse: HttpErrorResponse | any) {
  //    let fullErrorMessage: string;
  //    if (errorResponse instanceof HttpErrorResponse) {
  //        const error = errorResponse.error || JSON.stringify(errorResponse);
  //        fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
  //    } else {
  //        fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
  //    }
  //    console.error(fullErrorMessage);
  //    return Promise.reject(fullErrorMessage);
  //}
}
